import { Component, Input, ViewChild } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";
import { TranslationService } from "../../_services/translation.service";
import { AppUserModel } from "../../admin/users/user-management-models/app-user.model";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { applicationUsersMock } from "../../admin/users/mocks/app-users-mock";
import {
  UserManagementService,
  UsersTableSearchState,
} from "../../_services/user-management.service";
import { baseDiscountMocks } from "../../admin/discounts/mock/baseDiscount.mock";
import { BaseDiscountModel } from "../../admin/discounts/discount-models/BaseDiscountModel";
import { DiscountManagementPageComponent } from "../../admin/discounts/discount-management-page/discount-management-page.component";
import { EventsService } from "../../_services/eventsServices/events.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { DataService } from "../../_services/data.service";
import { AuthenticationService } from "../../_services/authentication.service";
import { PopoverService } from "../../_services/popover.service";
import { PasswordResetService } from "../../_services/password-reset.service";
import { DiscountManagementService } from "../../_services/discount-management.service";
import { DevToolsService } from "../../_services/dev-tools.service";
import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";

@Component({
  selector: "dev-discount-table-story-component",
  template: `
    <div
      class="admin-page-wrapper user-management-page"
      style="max-width: 980px;"
    >
      <div class="admin-page-header-row" style="width: unset!important;">
        <h4>
          {{ (translations$ | async)?.subsidies }}
        </h4>
        <div
          [ngClass]="{ 'has-more-options': false }"
          class="create-button-container"
        >
          <div
            aria-roledescription="new event button"
            class="add-event-button"
            role="button"
          >
            <span class="button-text">
              {{ (translations$ | async).add_subsidy }}</span
            >
          </div>
          <div class="figma-link-position">
            <figma-link
              figmaLink="https://www.figma.com/design/Rx4ti93iJfIvWPEHTRGpgT/Noal-_-Harshama?node-id=571-2330&node-type=canvas&t=KZ01YQPSRZMY55bB-0"
            ></figma-link>
          </div>
        </div>
      </div>

      <div class="search-result-info" id="search-results-info">
        <div id="found-results">
          <span>
            {{ (translations$ | async)?.were_found }} 35
            {{ (translations$ | async)?.results }}
          </span>
        </div>
        <div id="found-results-total-funds">
          <span>
            {{ (translations$ | async)?.total_subsidies_for_search }} 35{{
              (translations$ | async)?.new_shekel
            }}
          </span>
        </div>
      </div>
      <div class="admin-page-table">
        <div
          [immediateCallback]="false"
          [scrollCallback]="scrollCallback"
          appInfiniteScroller
          class="admin-page-table-scroll-container"
          scrollPercent="99"
        >
          <div style="direction: rtl">
            <discount-management-row
              (rowEvent)="rowEventHandler($event)"
              *ngFor="let user of $_DiscountTable | async; let i = index"
              [discount]="devBaseDiscountMocks[i]"
              [isSelected]="
                selectedDiscountId ===
                devBaseDiscountMocks[i].discountId.toString()
              "
            >
            </discount-management-row>
          </div>
          <div
            *ngIf="
              ($_DiscountTable | async).length > 6 &&
              !($usersTableSearchState | async)?.next
            "
            class="no-results-found"
          >
            סוף תוצאות החיפוש
          </div>
          <div
            *ngIf="
              ($_DiscountTable | async).length > 0 &&
              ($_DiscountTable | async).length < 7 &&
              !($usersTableSearchState | async)?.next
            "
            class="search-results-padding"
          ></div>
        </div>

        <div
          *ngIf="
            ($_DiscountTable | async).length === 0 &&
            ($usersTableSearchState | async)
          "
          class="no-results-found"
        >
          לא נמצאו תוצאות
        </div>
      </div>
    </div>
  `,
  styleUrls: [
    "../../admin/events-screen/parent-events-page/parent-events-page.component.scss",
    "../../admin/discounts/discount-management-page/discount-management-page.component.scss",
  ],
})
export class DevDiscountTableStoryComponent extends DiscountManagementPageComponent {
  public translations$: Observable<ITranslations>;
  public readonly $_DiscountTable: BehaviorSubject<AppUserModel[]> =
    new BehaviorSubject<AppUserModel[]>(applicationUsersMock);
  public readonly $discountTable: BehaviorSubject<BaseDiscountModel[]> =
    new BehaviorSubject<BaseDiscountModel[]>(baseDiscountMocks);
  public readonly devBaseDiscountMocks: BaseDiscountModel[] = baseDiscountMocks;
  public scrollCallback: ($event: any) => void;
  public readonly $usersTableSearchState: BehaviorSubject<UsersTableSearchState> =
    new BehaviorSubject<UsersTableSearchState>(null);

  constructor(
    protected discountManagementService: DiscountManagementService,
    devToolsService: DevToolsService,
    protected eventsService: EventsService,
    protected modalService: NgbModal,
    protected router: Router,
    protected dataService: DataService,
    protected authenticationService: AuthenticationService,
    protected translationService: TranslationService,
    protected popoverService: PopoverService,
    protected passwordResetService: PasswordResetService,
    protected sessionManagerService: SessionManagerService
  ) {
    super(
      discountManagementService,
      devToolsService,
      modalService,
      router,
      dataService,
      authenticationService,
      translationService,
      popoverService,
      passwordResetService,
      sessionManagerService
    );
    this.translations$ = this.translationService.translations;
  }
}



// WEBPACK FOOTER //
// ./src/app/development/ui/dev-discount-table-story.component.ts